import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate as useRouterNavigate } from 'react-router-dom';
import { IconButton } from '@mui/material';
import { useNavigate } from '@core/hooks/navigate.hook';
import { Routes } from '@core/constants/routes';

export interface BackButtonProps {
  backLink?: Routes | Routes[];
  options?: {
    backLinkParams?: Record<string, string | number>;
  };
  onClick?: () => void;
}

const BackButton = ({ backLink, onClick, options }: BackButtonProps) => {
  const routerNavigate = useRouterNavigate();
  const navigate = useNavigate();

  const handleBack = () => {
    if (backLink) navigate(backLink, { params: options?.backLinkParams });
    else routerNavigate(-1);
    onClick?.();
  };

  return (
    <IconButton onClick={handleBack}>
      <ArrowBackIcon />
    </IconButton>
  );
};

export default BackButton;
